var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "homePageWarp" },
    [
      _c("div", { class: ["navHdWarp2", _vm.opacity ? "isOpacity" : ""] }, [
        _c("div", { staticClass: "navHd" }, [
          _c(
            "div",
            { staticClass: "logoText2022", on: { click: _vm.isback2022 } },
            [_vm._v("\n        黑龙江省职业院校教师教学能力大赛\n      ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "navItemBox" },
            _vm._l(_vm.TEACHERLIST, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "navItem" },
                [
                  _c(
                    "router-link",
                    {
                      class: { actClass: index === _vm.actNum },
                      attrs: { to: item.linkUrl },
                    },
                    [_vm._v(_vm._s(item.name) + "\n          ")]
                  ),
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "login" }, [
            _vm.isBack
              ? _c(
                  "div",
                  { staticClass: "backToHt", on: { click: _vm.backToHt } },
                  [_vm._v("返回后台")]
                )
              : _c(
                  "div",
                  { staticClass: "username", on: { click: _vm.isLogin } },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.userLogin.username) +
                        "\n        "
                    ),
                  ]
                ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "main" }, [_c("router-view")], 1),
      _vm._v(" "),
      _c("div", { staticClass: "footerWarp" }, [
        _c("div", { staticClass: "footer" }, [
          _c("div", { staticClass: "leftFooter" }, [
            _c("p", { domProps: { innerHTML: _vm._s(_vm.footerTxt) } }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "loginDialog",
          attrs: {
            visible: _vm.loginDialog,
            "modal-append-to-body": true,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.loginDialog = $event
            },
          },
        },
        [
          _c("div", { staticClass: "l_W" }, [
            _c("div", { staticClass: "logoText" }, [
              _vm._v("\n        黑龙江省职业院校教师教学能力大赛\n      "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "right_w" },
              [
                _c("div", { staticClass: "userLogin" }, [_vm._v("欢迎登录")]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "userMsg",
                    attrs: { model: _vm.userMsg, rules: _vm.userRules },
                  },
                  [
                    this.prCode === "jiangxi"
                      ? _c(
                          "el-form-item",
                          {
                            staticClass: "loginType",
                            attrs: { label: "登录方式" },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.userMsg.loginType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.userMsg, "loginType", $$v)
                                  },
                                  expression: "userMsg.loginType",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("用户登录"),
                                ]),
                                _vm._v(" "),
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("专家登录"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "username" } },
                      [
                        _c("el-input", {
                          attrs: {
                            "prefix-icon": "el-icon-user",
                            placeholder: "请输入账号",
                          },
                          model: {
                            value: _vm.userMsg.username,
                            callback: function ($$v) {
                              _vm.$set(_vm.userMsg, "username", $$v)
                            },
                            expression: "userMsg.username",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "password" } },
                      [
                        _c("el-input", {
                          attrs: {
                            "prefix-icon": "el-icon-lock",
                            type: "password",
                            placeholder: "请输入密码",
                          },
                          model: {
                            value: _vm.userMsg.password,
                            callback: function ($$v) {
                              _vm.$set(_vm.userMsg, "password", $$v)
                            },
                            expression: "userMsg.password",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "verificationCode" } },
                      [
                        _c("el-input", {
                          staticClass: "validationCode",
                          attrs: {
                            "prefix-icon": "el-icon-full-screen",
                            type: "text",
                            maxlength: "4",
                            placeholder: "请输入验证码",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.login("userMsg")
                            },
                          },
                          model: {
                            value: _vm.userMsg.verificationCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.userMsg, "verificationCode", $$v)
                            },
                            expression: "userMsg.verificationCode",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "codeImg",
                            on: { click: _vm.getImgCode },
                          },
                          [
                            _c("img", {
                              attrs: { src: _vm.codeImg, alt: "获取失败" },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                0
                  ? _c(
                      "div",
                      { staticClass: "footerModles" },
                      [
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.checked,
                              callback: function ($$v) {
                                _vm.checked = $$v
                              },
                              expression: "checked",
                            },
                          },
                          [_vm._v("记住密码")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "register" }, [
                          _c("a", { attrs: { href: "##" } }, [
                            _vm._v("忘记密码"),
                          ]),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isEnter === true
                  ? _c(
                      "el-button",
                      {
                        staticClass: "homeLoginBtn",
                        attrs: { loading: _vm.loading, type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.login("userMsg")
                          },
                        },
                      },
                      [_vm._v("登录\n          ")]
                    )
                  : _c(
                      "el-button",
                      {
                        staticClass: "homeLoginBtn",
                        attrs: { type: "primary" },
                        on: { click: _vm.login },
                      },
                      [_vm._v("注册\n          ")]
                    ),
                _vm._v(" "),
                0
                  ? _c(
                      "span",
                      {
                        staticClass: "register",
                        on: {
                          click: function ($event) {
                            _vm.isEnter = false
                          },
                        },
                      },
                      [_vm._v("\n            没有账号? 立即注册\n          ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "reasonDia logBox pubDia",
          attrs: {
            title: "提示",
            visible: _vm.registerDia,
            width: "30%",
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.registerDia = $event
            },
          },
        },
        [
          _c("div", { staticClass: "reason" }, [
            _vm._v("\n      " + _vm._s(this.backReason) + "\n    "),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "submitBtn" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleClose } },
                [_vm._v(" 取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.toEdit } },
                [_vm._v(" 去修改")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }